import React, { Component } from "react";
import PropTypes from "prop-types";

import { Card, Form, Button, Input, message } from "antd";
import { connect } from "react-redux";

import RichTextEditor from "./rich-text-editor";
import FilesWall from "./files-wall";

import storageUtils from "../../utils/storageUtils";
import { req_add_tqa_b06, req_edit_tqa_b06 } from "../../api";
import { getNowAcademicYear } from "../../utils/dateUtil";

const Item = Form.Item;

class QuailtyManualLevelBModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    manual: PropTypes.object,
    modalstate: PropTypes.string,
  };

  state = {
    isUpdate: false,
    isInsert: false,
    item: {
      AcademicYear: getNowAcademicYear(new Date()),
      RecordVersion: "",
      DepartmentCode: this.props.manual.DepartmentCode,
      DepartmentName: this.props.manual.DepartmentName,
      RecordTitle: this.props.manual.DepartmentName + "品保實施及評量報告",
      RecordDescription: "",
      RecordFileUrl: "",
      RecordEditor: "",
      RecordCreator: "",
      RecordStatus: "EDIT",
    },
  };

  constructor(props) {
    super(props);

    this.get_files = React.createRef();
    this.editor = React.createRef();
  }

  UNSAFE_componentWillMount() {
    this.init();
  }

  componentDidMount() {}

  // 遠端數據處理 //////////////////////////////////////////////

  api_modify_item = async (item) => {
    //console.log(item);
    const { isUpdate } = this.state;

    if (isUpdate) {
      const result = await req_edit_tqa_b06(item, storageUtils.getUser().token);
      if (result.status === "success") {
        // console.log("req_edit_tqa_b06：", item);
        message.success(result.message);
      } else {
        message.error(result.message);
      }
    } else {
      // console.log("req_add_tqa_b06：", item);
      const result = await req_add_tqa_b06(item, storageUtils.getUser().token);
      if (result.status === "success") {
        message.success(result.message);
      } else {
        message.error(result.message);
      }
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init = () => {
    // console.log("this.props.manual", this.props.manual);
    const { Uid } = this.props.manual;
    if (Uid) {
      const item = this.props.manual;
      this.setState({ item, isUpdate: true });
    } else {
      this.setState({ isInsert: true });
    }
  };

  // 操作互動處理 //////////////////////////////////////////////

  onFinish = (values) => {
    // console.log("Success:", values);
    // console.log("Item:", this.state.item);
    const { AcademicYear } = values;
    const { isInsert } = this.state;
    const { Uid } = this.state.item;
    const { userCode } = storageUtils.getUser();
    const file = this.get_files.current.output_files();
    const attacheFileUrl = file.join();
    const recordDescription = this.editor.current.output_text();
    const { DepartmentCode, DepartmentName } = this.props.manual;
    if (isInsert) {
      const { RecordTitle } = values;
      const manual = {
        AcademicYear: AcademicYear,
        DepartmentCode: DepartmentCode,
        DepartmentName: DepartmentName,
        RecordTitle: RecordTitle,
        RecordDescription: recordDescription,
        RecordFileUrl: attacheFileUrl,
        RecordEditor: userCode,
        RecordCreator: userCode,
      };
      this.api_modify_item(manual);
    } else {
      const manual = {
        Uid: Uid,
        RecordFileUrl: attacheFileUrl,
        RecordEditor: userCode,
        RecordDescription: recordDescription,
        condition: "BASE",
      };
      this.api_modify_item(manual);
    }
  };

  ///////////////////////////////////////////////////////////

  render() {
    //console.log(this.props.modalstate);
    const { isUpdate } = this.state;
    const { Uid, AcademicYear, RecordTitle, RecordDescription, RecordFileUrl } =
      this.state.item;
    const fileUrlPath = "/api/UploadFile/AddInsideFile";
    const sourceFile =
      RecordFileUrl === ""
        ? []
        : [
            {
              Uid: Uid,
              FileNewName: "已附加檔案",
              FileUrl: RecordFileUrl,
            },
          ];
    return (
      <Card>
        <Form onFinish={this.onFinish} onFinishFailed={this.onFinishFailed}>
          <Item
            label="年度"
            name="AcademicYear"
            initialValue={AcademicYear}
            rules={[
              { required: true, whitespace: true, message: "AcademicYear" },
            ]}
          >
            <Input
              placeholder="輸入學年度"
              disabled={this.props.modalstate === "isEditModal"}
            />
          </Item>
          <Item label="名稱" name="RecordTitle" initialValue={RecordTitle}>
            <Input disabled />
          </Item>
          <Item label="說明" name="RecordDescription">
            <RichTextEditor
              ref={this.editor}
              edit_input_richtext={RecordDescription}
            />
          </Item>
          <Item label="附加檔案">
            <FilesWall
              ref={this.get_files}
              data_source={sourceFile}
              api_url={fileUrlPath}
            ></FilesWall>
          </Item>
          <Item>
            <Button type="primary" htmlType="submit" block>
              {isUpdate ? "更新" : "送出"}
            </Button>
          </Item>
        </Form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(QuailtyManualLevelBModal);
